import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Export types for TypeScript support
export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          display_name: string | null;
          tokens: number;
          is_admin: boolean;
          last_token_update: string | null;
          created_at: string;
          phone: string | null;
          city: string | null;
          postal_code: string | null;
          company: string | null;
          accepted_terms: boolean;
        };
        Insert: {
          id?: string;
          email: string;
          display_name?: string | null;
          tokens?: number;
          is_admin?: boolean;
          last_token_update?: string | null;
          created_at?: string;
          phone?: string | null;
          city?: string | null;
          postal_code?: string | null;
          company?: string | null;
          accepted_terms?: boolean;
        };
        Update: {
          id?: string;
          email?: string;
          display_name?: string | null;
          tokens?: number;
          is_admin?: boolean;
          last_token_update?: string | null;
          created_at?: string;
          phone?: string | null;
          city?: string | null;
          postal_code?: string | null;
          company?: string | null;
          accepted_terms?: boolean;
        };
      };
      token_transactions: {
        Row: {
          id: string;
          user_id: string;
          amount: number;
          type: string;
          description: string;
          created_at: string;
          created_by: string | null;
          checkout_session_id: string | null;
        };
        Insert: {
          id?: string;
          user_id: string;
          amount: number;
          type: string;
          description: string;
          created_at?: string;
          created_by?: string | null;
          checkout_session_id?: string | null;
        };
        Update: {
          id?: string;
          user_id?: string;
          amount?: number;
          type?: string;
          description?: string;
          created_at?: string;
          created_by?: string | null;
          checkout_session_id?: string | null;
        };
      };
      quotations: {
        Row: {
          id: string;
          user_id: string;
          origin: string;
          destination: string;
          distance: number;
          fuel_price: number;
          vehicle_type: string;
          trailer_type: string | null;
          total_cost: number;
          profit_margin: number | null;
          profit_amount: number | null;
          base_cost: number | null;
          cargo_type: string | null;
          risk_factor: number | null;
          risk_amount: number | null;
          created_at: string;
          map_image_url: string | null;
          origin_address: string | null;
          destination_address: string | null;
          cost_breakdown: any | null;
          toll_details: any | null;
          selected_currency: string | null;
          is_multi_segment_route: boolean | null;
          segment_distances: number[] | null;
          segment_durations: string[] | null;
          segment_load_status: string[] | null;
          waypoints: string[] | null;
          captured_map_image: string | null;
        };
        Insert: {
          id?: string;
          user_id: string;
          origin: string;
          destination: string;
          distance: number;
          fuel_price: number;
          vehicle_type: string;
          trailer_type?: string | null;
          total_cost: number;
          profit_margin?: number | null;
          profit_amount?: number | null;
          base_cost?: number | null;
          cargo_type?: string | null;
          risk_factor?: number | null;
          risk_amount?: number | null;
          created_at?: string;
          map_image_url?: string | null;
          origin_address?: string | null;
          destination_address?: string | null;
          cost_breakdown?: any | null;
          toll_details?: any | null;
          selected_currency?: string | null;
          is_multi_segment_route?: boolean | null;
          segment_distances?: number[] | null;
          segment_durations?: string[] | null;
          segment_load_status?: string[] | null;
          waypoints?: string[] | null;
          captured_map_image?: string | null;
        };
        Update: {
          id?: string;
          user_id?: string;
          origin?: string;
          destination?: string;
          distance?: number;
          fuel_price?: number;
          vehicle_type?: string;
          trailer_type?: string | null;
          total_cost?: number;
          profit_margin?: number | null;
          profit_amount?: number | null;
          base_cost?: number | null;
          cargo_type?: string | null;
          risk_factor?: number | null;
          risk_amount?: number | null;
          created_at?: string;
          map_image_url?: string | null;
          origin_address?: string | null;
          destination_address?: string | null;
          cost_breakdown?: any | null;
          toll_details?: any | null;
          selected_currency?: string | null;
          is_multi_segment_route?: boolean | null;
          segment_distances?: number[] | null;
          segment_durations?: string[] | null;
          segment_load_status?: string[] | null;
          waypoints?: string[] | null;
          captured_map_image?: string | null;
        };
      };
      toll_cache: {
        Row: {
          id: string;
          origin: string;
          destination: string;
          vehicle_type: string;
          toll_details: any;
          created_at: string;
          expires_at: string;
        };
        Insert: {
          id?: string;
          origin: string;
          destination: string;
          vehicle_type: string;
          toll_details: any;
          created_at?: string;
          expires_at: string;
        };
        Update: {
          id?: string;
          origin?: string;
          destination?: string;
          vehicle_type?: string;
          toll_details?: any;
          created_at?: string;
          expires_at?: string;
        };
      };
    };
  };
};